import React from 'react';
import { Form } from 'react-bootstrap';

interface Horarios {
    pinesHorarios: any;
}

export const TableRowHorarios: React.FC<Horarios> = (props: Horarios) => {
    const moment = require('moment');
    const { pinesHorarios } = props;

    const hourFormat = (value: any) => {
        return moment(value, 'HH:mm').format('HH:mm');
    }

    return (
        <>
            <tr className='tablaPinesHoras'>
                <td>
                    <span>Inicio</span>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.lun_hi)}
                        id="lun_hi"
                        name="lun_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.mar_hi) || ''}
                        id="mar_hi"
                        name="mar_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.mie_hi) || ''}
                        id="mie_hi"
                        name="mie_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.jue_hi) || ''}
                        id="jue_hi"
                        name="jue_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.vie_hi) || ''}
                        id="vie_hi"
                        name="vie_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.sab_hi) || ''}
                        id="sab_hi"
                        name="sab_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.dom_hi) || ''}
                        id="dom_hi"
                        name="dom_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.com_hi) || ''}
                        id="com_hi"
                        name="com_hi"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
            </tr>
            <tr className='tablaPinesHoras'>
                <td>
                    <span>Fin</span>
                </td>
                 <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.lun_hf) || ''}
                        id="lun_hf"
                        name="lun_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.mar_hf) || ''}
                        id="mar_hf"
                        name="mar_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.mie_hf) || ''}
                        id="mie_hf"
                        name="mie_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.jue_hf) || ''}
                        id="jue_hf"
                        name="jue_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.vie_hf) || ''}
                        id="vie_hf"
                        name="vie_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.sab_hf) || ''}
                        id="sab_hf"
                        name="sab_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.dom_hf) || ''}
                        id="dom_hf"
                        name="dom_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
                <td>
                    <Form.Control
                        value={hourFormat(pinesHorarios.com_hf) || ''}
                        id="com_hf"
                        name="com_hf"
                        type="time"
                        readOnly
                        disabled
                    >
                    </Form.Control>
                </td>
            </tr>
        </>
    )
}